<template>
  <div class="profit">
    <el-form class="custom-formScreen" inline :model="formScreen" ref="formScreen">
      <el-form-item label="分公司" prop="branchCompanyId" v-if="UserInfo.type === 1">
        <el-select
          filterable
          v-model="formScreen.branchCompanyId"
          value-key="company_id"
          @change="selectChange($event, 'listSonCompany')"
        >
          <el-option
            v-for="item in listBranchCompany"
            :key="item.company_id"
            :label="item.companyName"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="子公司" prop="sonCompanyId">
        <el-select
          filterable
          v-model="formScreen.sonCompanyId"
          value-key="rid"
          @change="selectChange($event, 'listDepartment')"
        >
          <el-option
            v-for="item in listSonCompany"
            :key="item.company_id"
            :label="item.companyName"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开始日期" prop="startTime">
        <el-date-picker
          v-model="formScreen.startTime"
          type="date"
          placeholder="选择时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="结束日期" prop="endTime">
        <el-date-picker
          v-model="formScreen.endTime"
          type="date"
          placeholder="选择时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">搜 索</el-button>
        <el-button type="primary" @click="resetForm">重 置</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="listTable" border v-loading="loadingTable">
      <el-table-column align="center" prop="time" label="日期"></el-table-column>
      <el-table-column align="center" prop="quantityOfOrder" label="订单量"></el-table-column>
      <el-table-column align="center" prop="totalAmountOfOrder" label="销售额"></el-table-column>
      <el-table-column align="center" prop="actualTotalCost" label="实收费用"></el-table-column>
      <template v-if="UserInfo.type === 2">
        <el-table-column align="center" prop="totalPlatformFeeIncome" label="平台费收入"></el-table-column>
        <el-table-column align="center" prop="totalPlatformFeeExpenditure" label="平台费支出"></el-table-column>
        <el-table-column align="center" prop="platformFeeIncome" label="平台费收益"></el-table-column>
      </template>
      <template v-else-if="UserInfo.type === 1">
        <el-table-column align="center" prop="totalPlatformFeeExpenditure" label="平台费"></el-table-column>
        <el-table-column align="center" prop="otherIncome" label="其他收益"></el-table-column>
        <el-table-column align="center" prop="totalRevenue" label="总收益"></el-table-column>
      </template>
    </el-table>

    <el-row class="pagination-box" type="flex" justify="center" align="middle">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-row>
  </div>
</template>

<script>
import { ajaxPost, Baseurl } from '../../../../api/api/api';
export default {
  name: 'Profit',
  props: ['dateData'],
  data() {
    return {
      UserInfo: {},
      formScreen: {
        startTime: '',
        endTime: '',
        branchCompanyId: '',
        sonCompanyId: '',
      },
      listTable: [],
      page: 1,
      size: 20,
      total: 0,
      listBranchCompany: [],
      listSonCompany: [],
      companyId: '',
      rid: '',
      system: '',
      loadingTable: false
    }
  },
  created() {
    this.UserInfo = JSON.parse(localStorage.getItem("role"));
    this.companyId = this.UserInfo.company_id
    this.rid = this.UserInfo.rid
    this.system = this.UserInfo.system

    this.init()
    this.getListTable()
  },
  watch: {
    dateData: {
      handler(newVal) {
        if (newVal) {
          this.formScreen.startTime = newVal.startTime
          this.formScreen.endTime = newVal.endTime
          // this.search();
        }
      },
      immediate: true
    }
  },
  methods: {
    init() {
      const { rid, system, company_id: companyId, type } = this.UserInfo;
      let listType = "";
      if (type === 1) {
        listType = "listBranchCompany";
      } else if (type === 2) {
        listType = "listSonCompany";
      }
      this.getNextPower(rid, system, companyId, listType);
    },
    getNextPower(rid, system, companyId, type) {
      const API = Baseurl + "roleController/selectNextInfoByRid";
      const paramsData = { rid, system, companyId };
      ajaxPost(API, paramsData).then(res => {
        const {
          data: { code, data },
        } = res;
        if (code === 200) {
          this[type] = data.next;
        }
      });
    },
    selectChange(event, type) {
      const { rid, system, company_id: companyId } = event;
      companyId && (this.companyId = companyId);
      rid && (this.rid = rid);
      system && (this.system = system);

      this.getNextPower(rid, system, companyId, type);

      if (type === "listDepartment") return;
      this.formScreen.sonCompanyId = {};
      this.listSonCompany = [];
    },
    getListTable() {
      const API = Baseurl + 'orderController/selectIncomeStatistics'
      const paramsData = {
        companyId: this.companyId,
        rid: this.rid,
        system: this.system,
        page: this.page,
        size: this.size,
        startTime: this.formScreen.startTime,
        endTime: this.formScreen.endTime
      }
      this.loadingTable = true
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        this.loadingTable = false
        if (code === 200) {
          this.listTable = data.list
          this.total = data.total
        }
      })
    },
    resetForm() {
      this.page = 1
      this.companyId = this.UserInfo.company_id
      this.rid = this.UserInfo.rid
      this.system = this.UserInfo.system
      this.formScreen.sonCompanyId = {};
      this.listSonCompany = [];
      this.$refs.formScreen.resetFields();

      this.getListTable()
    },
    search() {
      this.page = 1
      this.getListTable()
    },
    handleSizeChange(val) {
      this.size = val
      this.getListTable()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getListTable()
    },
  }
}
</script>

<style lang="scss" scoped>
.profit {
  margin-bottom:52px ;
  .pagination-box {
    width: calc(97% - 200px);
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 200px;
    padding: 10px;
    z-index: 999;
  }
}
</style>
